<template>
    <div class="pageBox">
        <PageComponent publicTemplateName="注册未报考" :publicStatus="1400"></PageComponent>
    </div>
</template>

<script>
import PageComponent from "./PageComponent"
export default {
    components: {PageComponent},
    data() {
        return{
            
        }
    },
    methods: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
}
</script>

<style lang="stylus" scoped>
    
</style>